import { Injectable } from '@angular/core';
import { Attributes, Span, SpanStatusCode, trace, Tracer } from '@opentelemetry/api';

/** Non-PII process metadata only — no client ids, amounts, tickers or user input. */
export interface JourneyEventAttributes {
  processType?: string;
  processStep?: string;
  errorCode?: string;
  transactionId?: string;
  accountType?: string;
}

const ATTR_PREFIX = 'coo.journey';

/** Instrumentation scope name (not `service.name`). */
export const JOURNEY_TRACER_NAME = 'coo-journey-telemetry';

@Injectable({ providedIn: 'root' })
export class TelemetryService {
  /** Global provider is registered eagerly by OtelModule. */
  private readonly tracer: Tracer = trace.getTracer(JOURNEY_TRACER_NAME);

  recordJourneyEvent(name: string, attributes: JourneyEventAttributes = {}, isError = false): void {
    const span: Span = this.tracer.startSpan(name, {
      attributes: this.toSpanAttributes(attributes),
    });

    if (isError) {
      span.setStatus({ code: SpanStatusCode.ERROR });
    }

    span.end();
  }

  private toSpanAttributes(attributes: JourneyEventAttributes): Attributes {
    const spanAttributes: Attributes = {};

    if (attributes.processType) {
      spanAttributes[`${ATTR_PREFIX}.process_type`] = attributes.processType;
    }
    if (attributes.processStep) {
      spanAttributes[`${ATTR_PREFIX}.process_step`] = attributes.processStep;
    }
    if (attributes.errorCode) {
      spanAttributes[`${ATTR_PREFIX}.error_code`] = attributes.errorCode;
    }
    if (attributes.transactionId) {
      spanAttributes[`${ATTR_PREFIX}.transaction_id`] = attributes.transactionId;
    }
    if (attributes.accountType) {
      spanAttributes[`${ATTR_PREFIX}.account_type`] = attributes.accountType;
    }

    return spanAttributes;
  }
}
